import React, { Component } from 'react';

interface IProps {
    id: string;
    label?: any;
    value: string;
    placeholder: string;
    classes?: string;
    onChange(v: any): void;
}

export class TextInput extends Component<IProps, any> {
    render() {
        return (
            <div className='grid justify-c'>
                {this.props.label &&
                    <label htmlFor={this.props.id}>{this.props.label}</label>
                }
                <input
                    id={this.props.id}
                    key={this.props.id + '-input'}
                    className={'text-input ' + this.props.classes ?? ''}
                    type="text"
                    autoComplete="off"
                    defaultValue={this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={this.props.onChange}
                />
            </div>
        );
    }
}
